var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5954 2.39262C14.1424 1.84561 14.1424 0.957266 13.5954 0.410257C13.0484 -0.136752 12.16 -0.136752 11.613 0.410257L7.005 5.02264L2.39262 0.414633C1.84561 -0.132376 0.957266 -0.132376 0.410257 0.414633C-0.136752 0.961642 -0.136752 1.84998 0.410257 2.39699L5.02264 7.005L0.414633 11.6174C-0.132376 12.1644 -0.132376 13.0527 0.414633 13.5997C0.961642 14.1468 1.84999 14.1468 2.39699 13.5997L7.005 8.98736L11.6174 13.5954C12.1644 14.1424 13.0527 14.1424 13.5997 13.5954C14.1468 13.0484 14.1468 12.16 13.5997 11.613L8.98736 7.005L13.5954 2.39262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/whiteCross.33e46b6efa5f59d0145faef622ecdb8c.svg";
export { ForwardRef as ReactComponent };